import { createDefaultStorageState, normalizeTrackerState } from './holdingStorage.js'

export const DATA_FILE_URL = '/data/etf-tracker-v1.json'
export const MOCK_DATA_FILE_URL = '/data/etf-tracker-v1.mock-90d.json'
export const LOCAL_UPDATE_URL = '/local-api/update-holdings'

function assertJsonText(text, message) {
  if (text.trimStart().startsWith('<')) {
    throw new Error(message)
  }
}

function parseStateText(text, message) {
  assertJsonText(text, message)

  try {
    return normalizeTrackerState(JSON.parse(text))
  } catch {
    throw new Error('資料檔不是有效 JSON，請確認 public/data/etf-tracker-v1.json 已正確產生。')
  }
}

export async function loadTrackerDataFile(dataFileUrlOrFetch = DATA_FILE_URL, fetchImpl = globalThis.fetch) {
  const dataFileUrl = typeof dataFileUrlOrFetch === 'string'
    ? dataFileUrlOrFetch
    : DATA_FILE_URL
  const effectiveFetch = typeof dataFileUrlOrFetch === 'function'
    ? dataFileUrlOrFetch
    : fetchImpl

  const response = await effectiveFetch(dataFileUrl, {
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  })

  if (response.status === 404) {
    return createDefaultStorageState()
  }

  const text = await response.text()
  if (!response.ok) {
    throw new Error('讀取資料檔失敗')
  }

  return parseStateText(text, '資料檔不是有效 JSON，請確認雲端部署包含 public/data/etf-tracker-v1.json。')
}

export async function updateTrackerDataFile(currentState, fetchImpl = globalThis.fetch) {
  const response = await fetchImpl(LOCAL_UPDATE_URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(currentState),
  })

  const text = await response.text()
  assertJsonText(text, '目前部署環境無法寫入資料檔。請在本機執行更新後，重新部署 public/data/etf-tracker-v1.json。')

  if (!response.ok) {
    try {
      const errorBody = JSON.parse(text)
      throw new Error(errorBody.message || '更新失敗')
    } catch (error) {
      if (error.message !== '更新失敗') {
        throw error
      }
      throw new Error('更新失敗')
    }
  }

  return parseStateText(text, '目前部署環境無法寫入資料檔。請在本機執行更新後，重新部署 public/data/etf-tracker-v1.json。')
}
